import generateAnnotation from "../generation/generateAnnotation";
import generateAssociations from "../generation/generateAssociations";
import generateBaseTrimMolding from "../generation/generateBaseTrimMolding";
import generateBlockPerimeters from "../generation/generateBlockPerimeters";
import generateBlocksActive from "../generation/generateBlocksActive";
import generateBuildingBounds from "../generation/generateBuildingBounds";
import generateCasework from "../generation/generateCasework";
import generateCeilings from "../generation/generateCeilings";
import generateColumns from "../generation/generateColumns";
import generateComponentFloors from "../generation/generateComponentFloors";
import generateComponentFoundations from "../generation/generateComponentFoundations";
import generateComponentRoomMappings from "../generation/generateComponentRoomMappings";
import generateCornerBoards from "../generation/generateCornerBoards";
import generateCrownTrimMolding from "../generation/generateCrownTrimMolding";
import generateDefaultExteriorCamera from "../generation/generateDefaultExteriorCamera";
import generateDimensions from "../generation/generateDimensions";
import generateDoorUnits from "../generation/generateDoorUnits";
import generateDriveways from "../generation/generateDriveways";
import generateEdgeBehaviors from "../generation/generateEdgeBehaviors";
import generateElectrical from "../generation/generateElectrical";
import generateElevationNotes from "../generation/generateElevationNotes";
import generateEvaluatedOptionSets from "../generation/generateEvaluatedOptionSets";
import generateExteriorFinishEdgeAnalyticEntities from "../generation/generateExteriorFinishEdgeAnalyticEntities";
import generateExteriorPalette from "../generation/generateExteriorPalette";
import generateFacades from "../generation/generateFacades";
import generateFacadeStrata from "../generation/generateFacadeStrata";
import generateFloorAreaTakeoffs from "../generation/generateFloorAreaTakeoffs";
import generateFloorHorizontalAssemblies from "../generation/generateFloorHorizontalAssemblies";
import generateFloorPaths from "../generation/generateFloorPaths";
import generateFloorPlates from "../generation/generateFloorPlates";
import generateFloorSystemBoundary from "../generation/generateFloorSystemBoundary";
import generateFloorSystems from "../generation/generateFloorSystems";
import generateFoundationHorizontalAssemblies from "../generation/generateFoundationHorizontalAssemblies";
import generateFoundationHorizontalAssembliesPaths from "../generation/generateFoundationHorizontalAssembliesPath";
import generateFoundationHorizontalAssemblyOpeningCuts from "../generation/generateFoundationHorizontalAssemblyOpeningCuts";
import generateFoundationPaths from "../generation/generateFoundationPaths";
import generateFoundationSystems from "../generation/generateFoundationSystems";
import generateGableEndWallFraming from "../generation/generateGableEndWallFraming";
import generateGroups from "../generation/generateGroups";
import generateHalfEdgeAssociations from "../generation/generateHalfEdgeAssociations";
import generateInteriorPalette from "../generation/generateInteriorPalette";
import generateLevelAttributes from "../generation/generateLevelAttributes";
import generateLevels from "../generation/generateLevels";
import generateLumberRails from "../generation/generateLumberRails";
import generateMeasurements from "../generation/generateMeasurements";
import generateModifiers from "../generation/generateModifiers";
import generateOpeningPlacement from "../generation/generateOpeningPlacement";
import generateOpenings from "../generation/generateOpenings";
import generateOptionSetEntityRelations from "../generation/generateOptionSetEntityRelations";
import generatePlanarGraphPerimeters from "../generation/generatePlanarGraphPerimeters";
import generatePlanarGraphs from "../generation/generatePlanarGraphs";
import generatePorches from "../generation/generatePorches";
import generateProps from "../generation/generateProps";
import generateRailings from "../generation/generateRailings";
import generateReflection from "../generation/generateReflection";
import generateRelatedRoomsMap from "../generation/generateRelatedRoomsMap";
import generateRelatedStairSystemsMap from "../generation/generateRelatedStairSystemsMap";
import generateResolvedLevelDatums from "../generation/generateResolvedLevelDatums";
import generateRoofDormers from "../generation/generateRoofDormers";
import generateRoofFraming from "../generation/generateRoofFraming";
import generateRoofSkylights from "../generation/generateRoofSkylights";
import generateRoofSystemClipping from "../generation/generateRoofSystemClipping";
import generateRoofSystemPerimeters from "../generation/generateRoofSystemPerimeters";
import generateRoofSystems from "../generation/generateRoofSystems";
import generateRoofVolumes from "../generation/generateRoofVolumes";
import generateRoofWalls from "../generation/generateRoofWalls";
import generateRoomFloorAssemblies from "../generation/generateRoomFloorAssemblies";
import generateRoomFloorFinishes from "../generation/generateRoomFloorFinishes";
import generateRoomLayoutContents from "../generation/generateRoomLayoutContents";
import generateRoomOutlines from "../generation/generateRoomOutlines";
import generateRooms from "../generation/generateRooms";
import generateSanitizedOptionChoices from "../generation/generateSanitizedOptionChoices";
import generateSelectorHighlightRelations from "../generation/generateSelectorHighlightRelations";
import generateSettings from "../generation/generateSettings";
import generateSheets from "../generation/generateSheets";
import generateSite from "../generation/generateSite";
import generateStairSystems from "../generation/generateStairSystems";
import generateWainscoting from "../generation/generateWainscoting";
import generateWallCuts from "../generation/generateWallCuts";
import generateWallFraming from "../generation/generateWallFraming";
import generateWallFramingFromWallPlanes from "../generation/generateWallFramingFromWallPlanes";
import generateWallMasses from "../generation/generateWallMasses";
import generateWallPaths from "../generation/generateWallPaths";
import generateWallPlaneFilterMatches from "../generation/generateWallPlaneFilterMatches";
import generateWallPlaneMasses from "../generation/generateWallPlaneMasses";
import generateWallPlaneOpeningDomainOperations from "../generation/generateWallPlaneOpeningDomainOperations";
import generateWallPlaneTrims from "../generation/generateWallPlaneTrims";
import generateWalls from "../generation/generateWalls";
import generateWallStructuralDomains from "../generation/generateWallStructuralDomains";
import generateWallSweeps from "../generation/generateWallSweeps";
import generateWindowShutters from "../generation/generateWindowShutters";
import generateWindowUnits from "../generation/generateWindowUnits";
import saveBuildingEntityGraph from "../generation/saveBuildingEntityGraph";
import generateBuildingGraph from "../generationTools/generateBuildingGraph";
import generateCeilingAnalyticEntities from "../generationTools/generateCeilingAnalyticTools";
import generateColumnAnalyticEntities from "../generationTools/generateColumnAnalyticTools";
import generateDatumAbstractions from "../generationTools/generateDatumAbstractions";
import generateDoorTrimAnalyticEntities from "../generationTools/generateDoorAnalyticTools";
import generateFloorStructureAnalyticEntities from "../generationTools/generateFloorStructureAnalyticTools";
import { generateFoundationAnalyticEntities } from "../generationTools/generatefoundationSystemAnalyticTools";
import { generateFoundationHorizontalAssemblyAnalyticEntities } from "../generationTools/generatefoundationSystemAnalyticTools";
import { generateFoundationSuperSystemAnalyticEntities } from "../generationTools/generatefoundationSystemAnalyticTools";
import generatePorchAnalyticEntities from "../generationTools/generatePorchAnalyticTools";
import generateRailingAnalyticEntities from "../generationTools/generateRailingAnalyticTools";
import generateRoofSoffitAnalyticEntities from "../generationTools/generateRoofSoffitAnalyticTools";
import generateRoofAnalyticEntities from "../generationTools/generateRoofSystemAnalyticTools";
import generateInteriorTrimAnalyticEntities from "../generationTools/generateTrimAnalyticTools";
import generateWallAnalyticEntities from "../generationTools/generateWallAnalyticEntities";
import generateWallStructuralDomainAnalyticEntities from "../generationTools/generateWallStructuralDomainAnalyticTools";
import generateWindowTrimAnalyticEntities from "../generationTools/generateWindowAnalyticTools";
import type { GenerationStages } from "../types/generateBuildingTypes";

export const defaultGenerationStages: GenerationStages = {
  generateSanitizedOptionChoices,
  generateGroups,
  generateAssociations,
  generateSettings,
  generateDatumAbstractions,
  generateComponentRoomMappings,
  generateLevels,
  generateLevelAttributes,
  generateExteriorPalette,
  generateInteriorPalette,
  generateBlocksActive,
  generateModifiers,
  generateRooms,
  generateComponentFloors,
  generateComponentFoundations,
  generateRelatedRoomsMap,
  generateRelatedStairSystemsMap,
  generateEdgeBehaviors,
  generateBlockPerimeters,
  generateReflection,
  generateFloorSystemBoundary,
  generateRoomFloorAssemblies,
  generateRoomFloorFinishes,
  generateResolvedLevelDatums,
  generateFacades,
  generateFacadeStrata,
  generatePlanarGraphs,
  generatePlanarGraphPerimeters,
  generateFoundationHorizontalAssembliesPaths,
  generateHalfEdgeAssociations,
  generateRoofSystemPerimeters,
  generateBuildingGraph,
  generateWallPlaneFilterMatches,
  generateWallPlaneMasses,
  generateOpeningPlacement,
  generateWallPaths,
  generateWallMasses,
  generateOpenings,
  generateWallCuts,
  generateFloorPlates,
  generateRoofVolumes,
  generateRoofSystems,
  generateRoofDormers,
  generateRoofSkylights,
  generateStairSystems,
  generateFoundationHorizontalAssemblies,
  generateWalls,
  generateWallPlaneOpeningDomainOperations,
  generateRoofWalls,
  generateRoomOutlines,
  generateWindowUnits,
  generatePorches,
  generateRoofSystemClipping,
  generateRoofFraming,
  generateProps,
  generateCasework,
  generateRoomLayoutContents,
  generateFloorPaths,
  generateWainscoting,
  generateColumns,
  generateFoundationPaths,
  generateFloorSystems,
  generateMeasurements,
  generateCeilings,
  generateDoorUnits,
  generateCornerBoards,
  generateBaseTrimMolding,
  generateCrownTrimMolding,
  generateWallSweeps,
  generateWallPlaneTrims,
  generateWindowShutters,
  generateFoundationHorizontalAssemblyOpeningCuts,
  generateFoundationSystems,
  generateWallFraming,
  generateGableEndWallFraming,
  generateWallFramingFromWallPlanes,
  generateAnnotation,
  generateBuildingBounds,
  generateRailings,
  generateSite,
  generateDriveways,
  generateElectrical,
  generateDimensions,
  generateSelectorHighlightRelations,
  generateFloorAreaTakeoffs,
  generateSheets,
  generateDefaultExteriorCamera,
  generateElevationNotes,
  generateOptionSetEntityRelations,
  generateEvaluatedOptionSets,
  generateFoundationAnalyticEntities,
  generateColumnAnalyticEntities,
  generatePorchAnalyticEntities,
  generateFoundationSuperSystemAnalyticEntities,
  generateFoundationHorizontalAssemblyAnalyticEntities,
  generateWallAnalyticEntities,
  generateRoofAnalyticEntities,
  generateCeilingAnalyticEntities,
  generateRoofSoffitAnalyticEntities,
  generateDoorTrimAnalyticEntities,
  generateWindowTrimAnalyticEntities,
  generateInteriorTrimAnalyticEntities,
  generateRailingAnalyticEntities,
  generateWallStructuralDomains,
  generateWallStructuralDomainAnalyticEntities,
  generateFloorHorizontalAssemblies,
  generateLumberRails,
  generateFloorStructureAnalyticEntities,
  generateExteriorFinishEdgeAnalyticEntities,
  saveBuildingEntityGraph,
} as const;
